import React from 'react';

const Button = ({
    children,
    onClick,
    variant = 'primary',
    disabled = false,
    loading = false,
    fullWidth = false,
    className = '',
    type = 'button'
}) => {
    const baseStyles = "py-[16px] px-[32px] rounded-[12px] font-semibold text-[20px] leading-[1.1] tracking-[-0.1px] transition-all duration-200 transform active:scale-95 flex items-center justify-center select-none";

    const variants = {
        primary: "bg-purple text-cream hover:bg-purple-hover",
        secondary: "bg-white text-purple border border-border-add hover:bg-purple-light hover:border-purple",
        ghost: "bg-transparent text-purple hover:bg-purple-light"
    };

    const disabledStyles = "bg-gray-200 text-gray-400 cursor-not-allowed opacity-60 transform-none active:scale-100 hover:bg-gray-200";

    // Use disabled styles if disabled OR loading
    const currentVariantStyles = (disabled || loading) ? disabledStyles : variants[variant];

    return (
        <button
            type={type}
            onClick={onClick}
            disabled={disabled || loading}
            className={`
        ${baseStyles}
        ${currentVariantStyles}
        ${fullWidth ? 'w-full' : ''}
        ${className}
      `}
        >
            {loading ? (
                <>
                    <svg className="animate-spin -ml-1 mr-3 h-5 w-5 text-current" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                        <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                        <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                    </svg>
                    Processing...
                </>
            ) : children}
        </button>
    );
};

export default Button;
